<template>
  <section v-if="idSubscriber">
    <a
        v-if="$_updateActionAllowed"
        @click.stop.prevent="$router.push({name: 'subscriberNewDashboardCarousel', params: {idSubscriber: idSubscriber}})"
        class="tab_button tab_button_add"
        :title="$gettext('Přidat carousel')">
      Přidat carousel
    </a>
    <carousels-list
    :id-subscriber="idSubscriber" />
  </section>
</template>

<script>
import CarouselsList from "./CarouselsList";

export default {
  name: "Dashboard",
  components: {CarouselsList},
  props:{
    subscriber: Object
  },
  computed: {
    idSubscriber(){
      if(this.subscriber && 'id' in this.subscriber){
        return this.subscriber.id;
      }else{
        return null;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/dashboard/Dashboard.vue